
import { Star, Quote } from "lucide-react";
import testimonialBakeryBg from "@/assets/testimonial-bakery-bg.webp";

const SocialProof = () => {
  return (
    <section className="py-16 relative overflow-hidden">
      {/* Testimonial Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{backgroundImage: `url(${testimonialBakeryBg})`}}
      ></div>
      
      {/* Warm Overlay for Readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-900/75 via-amber-900/70 to-yellow-900/75"></div>
      
      {/* Subtle Pattern Overlay */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="relative container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-white drop-shadow-lg">What Our Customers Say</h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-xl border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="flex items-center mb-4">
              <Quote className="h-6 w-6 text-yellow-300 mr-2" />
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-yellow-300 fill-current" />
                ))}
              </div>
            </div>
            <p className="text-gray-100 mb-4">
              "Processing Bros cut our fees by 95% with their cash discount setup. Customers adapted in a week and onboarding took 48 hours."
            </p>
            <p className="font-semibold text-yellow-200">- Sarah M., Restaurant Owner</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-xl border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="flex items-center mb-4">
              <Quote className="h-6 w-6 text-yellow-300 mr-2" />
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-yellow-300 fill-current" />
                ))}
              </div>
            </div>
            <p className="text-gray-100 mb-4">
              "Saved $8,600 in the first year and reduced chargebacks by 32%. DoorDash integration streamlined online orders."
            </p>
            <p className="font-semibold text-yellow-200">- Mike T., Cafe Owner</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-xl border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="flex items-center mb-4">
              <Quote className="h-6 w-6 text-yellow-300 mr-2" />
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-yellow-300 fill-current" />
                ))}
              </div>
            </div>
            <p className="text-gray-100 mb-4">
              "We keep 100% of our sales now with dual pricing. Support is fast and the POS is easy for new staff to learn."
            </p>
            <p className="font-semibold text-yellow-200">- Jennifer L., Retail Store</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
